// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PdfModal-module__overlay___Xxsc5 {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(24, 24, 27, 0.55);
}

.PdfModal-module__dialog___J3Yyp {
  display: flex;
  flex-direction: column;
  width: min(960px, 100%);
  height: min(90vh, 100%);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.PdfModal-module__header___jF9s6 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e4e7;
}

.PdfModal-module__heading___b1BDH {
  flex: 1;
  min-width: 0;
}

.PdfModal-module__title___U18hf {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #18181b;
}

.PdfModal-module__subtitle___mZziq {
  margin: 4px 0 0;
  font-size: 13px;
  color: #71717a;
}

.PdfModal-module__headerButton___kGFuB {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  text-decoration: none;
}
.PdfModal-module__headerButton___kGFuB:hover {
  border-color: #18181b;
  color: #18181b;
}

.PdfModal-module__headerIcon___qtVcq {
  color: #71717a;
}

.PdfModal-module__close___dPsA8 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #a1a1aa;
  border-radius: 8px;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
}
.PdfModal-module__close___dPsA8:hover {
  border-color: #18181b;
  color: #18181b;
}
.PdfModal-module__close___dPsA8:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: 2px;
}

.PdfModal-module__viewer___wwhex {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.PdfModal-module__fallback___grWO9 {
  padding: 24px;
  font-size: 14px;
  color: #52525b;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/PdfModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;AACJ;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;AAGE;EACE,0BAAA;EACA,mBAAA;AADJ;;AAKA;EACE,OAAA;EACA,WAAA;EACA,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAFF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(24, 24, 27, 0.55);\n}\n\n.dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(960px, 100%);\n  height: min(90vh, 100%);\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.heading {\n  flex: 1;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.headerButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  text-decoration: none;\n\n  &:hover {\n    border-color: #18181b;\n    color: #18181b;\n  }\n}\n\n.headerIcon {\n  color: #71717a;\n}\n\n.close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #a1a1aa;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #52525b;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #18181b;\n    color: #18181b;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: 2px;\n  }\n}\n\n.viewer {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n\n.fallback {\n  padding: 24px;\n  font-size: 14px;\n  color: #52525b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `PdfModal-module__overlay___Xxsc5`,
	"dialog": `PdfModal-module__dialog___J3Yyp`,
	"header": `PdfModal-module__header___jF9s6`,
	"heading": `PdfModal-module__heading___b1BDH`,
	"title": `PdfModal-module__title___U18hf`,
	"subtitle": `PdfModal-module__subtitle___mZziq`,
	"headerButton": `PdfModal-module__headerButton___kGFuB`,
	"headerIcon": `PdfModal-module__headerIcon___qtVcq`,
	"close": `PdfModal-module__close___dPsA8`,
	"viewer": `PdfModal-module__viewer___wwhex`,
	"fallback": `PdfModal-module__fallback___grWO9`
};
module.exports = ___CSS_LOADER_EXPORT___;
